import { Injectable } from '@angular/core';
import {
    RideType,
    UserStoreService,
} from '@polaris-customerweb/sharedcomponents.core';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RideTypeService {
    rideType$: Observable<RideType | undefined>;
    isSnoRideType$: Observable<boolean>;

    private rideTypeSubject = new BehaviorSubject<RideType | undefined>(
        undefined
    );

    constructor(private userStoreService: UserStoreService) {
        this.rideType$ = this.rideTypeSubject.asObservable();
        this.isSnoRideType$ = this.rideType$.pipe(
            map((type) => type === 'SNO')
        );
    }

    setRideType(rideType: RideType) {
        this.rideTypeSubject.next(rideType);
        this.userStoreService.set('currentRideType', rideType);
    }
}
